import React from 'react';
import { GlassGradient, GlassPanel, Handle, BattenteTriangleFill, AntaRibaltaFill, VasistasFill, FixedMark, SlidingArrow, BilicoH, BilicoV } from './primitives';

export const slidingDoor = () => (
  <svg viewBox="0 0 120 100" className="w-full h-full">
    <GlassGradient id="g_sd" />
    <GlassPanel x={8} y={8} w={52} h={84} gradId="g_sd" />
    <GlassPanel x={60} y={8} w={52} h={84} gradId="g_sd" />
    <rect x={4} y={4} width={112} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <SlidingArrow x={40} y={50} direction="right" length={30} />
  </svg>
);

export const scorriRibaltaPatio = () => (
  <svg viewBox="0 0 120 120" className="w-full h-full">
    <GlassGradient id="g_srp" />
    <GlassPanel x={8} y={8} w={52} h={104} gradId="g_srp" />
    <GlassPanel x={60} y={8} w={52} h={104} gradId="g_srp" />
    <rect x={4} y={4} width={112} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={60} y1={8} x2={60} y2={112} stroke="#222" strokeWidth="0.8" />
    <FixedMark x={8} y={8} w={52} h={104} />
    <SlidingArrow x={95} y={60} direction="left" length={20} />
    <polygon points="86,8 60,112 112,112" fill="none" stroke="#0055CC" strokeWidth="1.2" strokeDasharray="4,2" />
  </svg>
);

export const minimalSliding = () => (
  <svg viewBox="0 0 120 100" className="w-full h-full">
    <GlassGradient id="g_ms" />
    <GlassPanel x={6} y={6} w={54} h={88} gradId="g_ms" />
    <GlassPanel x={60} y={6} w={54} h={88} gradId="g_ms" />
    <rect x={4} y={4} width={112} height={92} fill="none" stroke="#222" strokeWidth="1.5" />
    <SlidingArrow x={40} y={50} direction="right" length={30} />
  </svg>
);

export const slidingDoor4 = () => (
  <svg viewBox="0 0 160 100" className="w-full h-full">
    <GlassGradient id="g_sd4" />
    <GlassPanel x={8} y={8} w={35} h={84} gradId="g_sd4" />
    <GlassPanel x={43} y={8} w={35} h={84} gradId="g_sd4" />
    <GlassPanel x={82} y={8} w={35} h={84} gradId="g_sd4" />
    <GlassPanel x={117} y={8} w={35} h={84} gradId="g_sd4" />
    <rect x={4} y={4} width={152} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={43} y1={8} x2={43} y2={92} stroke="#222" strokeWidth="0.8" />
    <line x1={78} y1={8} x2={78} y2={92} stroke="#222" strokeWidth="0.8" />
    <line x1={117} y1={8} x2={117} y2={92} stroke="#222" strokeWidth="0.8" />
  </svg>
);

export const slidingDoor3 = () => (
  <svg viewBox="0 0 140 100" className="w-full h-full">
    <GlassGradient id="g_sd3" />
    <GlassPanel x={8} y={8} w={40} h={84} gradId="g_sd3" />
    <GlassPanel x={52} y={8} w={40} h={84} gradId="g_sd3" />
    <GlassPanel x={96} y={8} w={40} h={84} gradId="g_sd3" />
    <rect x={4} y={4} width={132} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={48} y1={8} x2={48} y2={92} stroke="#222" strokeWidth="0.8" />
    <line x1={92} y1={8} x2={92} y2={92} stroke="#222" strokeWidth="0.8" />
    <SlidingArrow x={20} y={50} direction="right" length={20} />
  </svg>
);

export const foldingSystem = () => (
  <svg viewBox="0 0 140 100" className="w-full h-full">
    <GlassGradient id="g_fs" />
    <GlassPanel x={8} y={8} w={28} h={84} gradId="g_fs" />
    <GlassPanel x={40} y={8} w={28} h={84} gradId="g_fs" />
    <GlassPanel x={72} y={8} w={28} h={84} gradId="g_fs" />
    <GlassPanel x={104} y={8} w={28} h={84} gradId="g_fs" />
    <rect x={4} y={4} width={132} height={92} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={36} y1={20} x2={36} y2={80} stroke="#0055CC" strokeWidth="1" strokeDasharray="4,3" />
    <line x1={68} y1={20} x2={68} y2={80} stroke="#0055CC" strokeWidth="1" strokeDasharray="4,3" />
    <line x1={100} y1={20} x2={100} y2={80} stroke="#0055CC" strokeWidth="1" strokeDasharray="4,3" />
  </svg>
);

export const patio2Door = () => (
  <svg viewBox="0 0 120 120" className="w-full h-full">
    <GlassGradient id="g_pat2" />
    <GlassPanel x={8} y={8} w={52} h={104} gradId="g_pat2" />
    <GlassPanel x={60} y={8} w={52} h={104} gradId="g_pat2" />
    <rect x={4} y={4} width={112} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={60} y1={8} x2={60} y2={112} stroke="#222" strokeWidth="0.8" />
  </svg>
);

export const patio3Door = () => (
  <svg viewBox="0 0 140 120" className="w-full h-full">
    <GlassGradient id="g_pat3" />
    <GlassPanel x={8} y={8} w={40} h={104} gradId="g_pat3" />
    <GlassPanel x={52} y={8} w={40} h={104} gradId="g_pat3" />
    <GlassPanel x={96} y={8} w={40} h={104} gradId="g_pat3" />
    <rect x={4} y={4} width={132} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={52} y1={8} x2={52} y2={112} stroke="#222" strokeWidth="0.8" />
    <line x1={96} y1={8} x2={96} y2={112} stroke="#222" strokeWidth="0.8" />
  </svg>
);

export const patio4Door = () => (
  <svg viewBox="0 0 160 120" className="w-full h-full">
    <GlassGradient id="g_pat4" />
    <GlassPanel x={8} y={8} w={35} h={104} gradId="g_pat4" />
    <GlassPanel x={47} y={8} w={35} h={104} gradId="g_pat4" />
    <GlassPanel x={86} y={8} w={35} h={104} gradId="g_pat4" />
    <GlassPanel x={125} y={8} w={35} h={104} gradId="g_pat4" />
    <rect x={4} y={4} width={152} height={112} fill="none" stroke="#222" strokeWidth="2.5" />
    <line x1={47} y1={8} x2={47} y2={112} stroke="#222" strokeWidth="0.8" />
    <line x1={86} y1={8} x2={86} y2={112} stroke="#222" strokeWidth="0.8" />
    <line x1={125} y1={8} x2={125} y2={112} stroke="#222" strokeWidth="0.8" />
  </svg>
);

